import { Tooltip } from 'radix-ui';
import { ReactNode } from 'react';

type HelperTooltipProps = {
  children: ReactNode;
  content: ReactNode;
  contentClassName?: string;
  delayDuration?: number;
  disableHoverableContent?: boolean;
  sideOffset?: number;
  noBorder?: boolean;
};

export const HelperTooltip = ({
  children,
  content,
  contentClassName,
  delayDuration = 200,
  disableHoverableContent = true,
  sideOffset,
}: HelperTooltipProps) => {
  return (
    <Tooltip.Provider>
      <Tooltip.Root disableHoverableContent={disableHoverableContent} delayDuration={delayDuration}>
        <Tooltip.Trigger asChild>{children}</Tooltip.Trigger>
        <Tooltip.Portal container={document.getElementById('ui-wrapper')}>
          <Tooltip.Content className={`${contentClassName}`} sideOffset={sideOffset}>
            {content}
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};
